<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10 16.001c-3.308 0-6-1.122-6-2.5v-5c0 .666.626 1.294 1.76 1.766 1.354.512 2.793.761 4.24.734 3.307 0 6-1.121 6-2.5v5c0 1.378-2.692 2.5-6 2.5z" fill="currentColor"/><g opacity=".75"><path d="M16 6c0 1.657-2.686 3-6 3S4 7.657 4 6s2.686-3 6-3 6 1.343 6 3z" fill="currentColor"/><path d="M4 12H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.171c-.66-.115-1.33-.172-2-.171-3.308 0-6 1.346-6 3v6z" opacity=".6" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering108',
});
</script>
